module.exports = __webpack_public_path__ + "img/scene_5.9caaa393.png";